// helpers Web Push del frontend: pedir permiso, suscribir y registrar en el backend.

import { leerToken } from './api.ts';

const API_BASE = import.meta.env.VITE_API_URL ?? '';
const VAPID_PUBLIC_KEY_URL = `${API_BASE}/api/push/vapid-public-key`;

async function urlBase64ToUint8Array(base64String: string): Promise<Uint8Array> {
  const pad = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + pad).replace(/-/g, '+').replace(/_/g, '/');
  const buff = await fetch(`data:application/octet-stream;base64,${base64}`).then((r) => r.arrayBuffer());
  return new Uint8Array(buff);
}

export async function activarPushSiPuede(): Promise<void> {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;
  const permiso = await Notification.requestPermission();
  if (permiso !== 'granted') return;

  try {
    const r = await fetch(VAPID_PUBLIC_KEY_URL, {
      headers: { Authorization: `Bearer ${leerToken()}` },
    });
    if (!r.ok) return;
    const { publicKey } = (await r.json()) as { publicKey: string };
    if (!publicKey) return;

    const reg = await navigator.serviceWorker.ready;
    const key = await urlBase64ToUint8Array(publicKey);
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: key.buffer as ArrayBuffer,
      });
    }
    await fetch(`${API_BASE}/api/push/suscribir`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${leerToken()}`,
      },
      body: JSON.stringify({
        endpoint: sub.endpoint,
        keys: sub.toJSON().keys,
      }),
    });
  } catch (e) {
    console.warn('No se pudo suscribir Push:', e);
  }
}